import { ReactElement } from "react";
import { LoadingIndicator } from "./Loading";

export const GridLoadingOverlay = (): ReactElement => {
  return <LoadingIndicator show></LoadingIndicator>;
};
